import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { Tooltip, TooltipContent, TooltipTrigger } from "~/components/ui";

interface DipReadOnlyTooltipProps {
  children: ReactNode;
  disabled: boolean;
  ariaLabel: string;
}

export function DipReadOnlyTooltip({ children, disabled, ariaLabel }: DipReadOnlyTooltipProps) {
  const { t } = useTranslation();

  if (!disabled) return <>{children}</>;

  const readOnlyExplanation = t("feature.dataImportProjects.v2.lifecycle.readOnly");

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        {/* biome-ignore lint/a11y/useSemanticElements: A semantic button cannot wrap the disabled child button. */}
        <span className="inline-flex" role="button" aria-disabled="true" tabIndex={0} aria-label={ariaLabel}>
          {children}
        </span>
      </TooltipTrigger>
      <TooltipContent>{readOnlyExplanation}</TooltipContent>
    </Tooltip>
  );
}
